import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './FHIRQueryRequestTemplates.scss';
import { Base_RequestTemplate } from '../../Page_BaseSandbox/Base_RequestTemplate/index.js';
import { ModuleFE_SandboxFHIRQuery } from '../../modules/ModuleFE_SandboxFHIRQuery/index.js';
import { _className, Button, LL_H_C, LL_V_L, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { sortArray } from '@nu-art/ts-common';
import { ICONS } from '@app/styles/icons/icons';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/index';
import { ModuleFE_EMInterface } from '../../../../_entity/runtime/em-interface/index.js';
export class FHIRQueryRequestTemplates extends Base_RequestTemplate {
    async getTemplates() {
        return ModuleFE_SandboxFHIRQuery.listTemplates();
    }
    renderTemplate(template) {
        return _jsx("div", { className: 'predefined-option__label', children: template.label });
    }
    async sendRequest(id, requestType) {
        ModuleFE_SandboxFHIRQuery.addMessageToHistory({ type: 'sent', content: id });
        const response = await ModuleFE_EMInterface.vv1.sandbox.getFHIRQuerySandbox({
            method: requestType,
            id
        }).executeSync();
        const content = typeof response.response === 'string' ? response.response : JSON.stringify(response.response);
        ModuleFE_SandboxFHIRQuery.addMessageToHistory({ type: 'received', content });
    }
    renderRead = () => (_jsxs(LL_V_L, { className: 'read-tab', children: [_jsx(TS_InputV2, { type: "text", onChange: (value) => this.setState({ documentId: value }), placeholder: "enter id", style: { fontFamily: 'monospace', fontSize: 15 }, value: this.state.documentId, defaultValue: '' }), _jsx(LL_H_C, { className: 'action-button', children: _jsx(Button, { variant: 'secondary', onClick: () => this.sendRequest(this.state.documentId, 'READ'), children: "Search" }) })] }));
    renderQueries = () => (_jsxs(LL_V_L, { className: 'order-request-templates', children: [_jsx("div", { className: 'order-request-templates__header', onClick: () => this.forceUpdate(), children: "Templates" }), _jsx(LL_V_L, { className: 'templates-container', children: sortArray(this.state.templates, ((template) => template.label?.trim())).map(((template, i) => {
                    const className = _className('predefined-option', i === this.state.selectedIndex && 'selected');
                    return _jsxs(LL_H_C, { className: className, onClick: () => {
                            this.selectTemplate(template, i);
                        }, children: [this.renderTemplate(template), _jsx(ICONS.send.component, { onClick: () => this.sendRequest(template.content._id, 'SEARCH') })] }, i);
                })) })] }));
    getTabs = () => {
        const tabs = [];
        tabs.push({
            uid: 'fhir-queries',
            title: 'Queries',
            content: () => this.renderQueries()
        });
        tabs.push({
            uid: 'fhir-read',
            title: 'Read',
            content: () => this.renderRead()
        });
        return tabs;
    };
    render = () => _jsx(TS_Tabs, { id: 'fhir-query-templates', tabs: this.getTabs() });
}
//# sourceMappingURL=FHIRQueryRequestTemplates.js.map